// @flow
import * as React from 'react'
import type { PropsSchema, EasyAction, BasicProps } from '../../../type'
import computeData from '../../hoc/computeData'
import { delayPromise } from 'frame/core/promise'
import styles from './RectZhuanPan.scss'
import $ from 'jquery'

type Props = BasicProps & {
  customProps?: {
    $comp: {
      rectConfig?: {
        backgroundImage?: {
          url: string
        },
        defaultImage?: {
          url: string
        },
        turnImage?: {
          url: string
        }
      }
    }
  },
  children: React.ChildrenArray<React.Node>,
  callActions: (actionName: string, dynamicData: any) => {},
  backgroundImage: ?{
    url: string
  },
  defaultImage: ?{
    url: string
  },
  turnImage: ?{
    url: string
  }
};

type State = {
  currentNum: number,
  drawDone: boolean,
  speed: number,
  targetNum: Array<string>
};

@computeData({ includeData: true })
export default class extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'image',
      key: 'backgroundImage',
      title: '背景图片'
    },
    {
      type: 'image',
      key: 'defaultImage',
      title: '转盘原始图片'
    },
    {
      type: 'image',
      key: 'turnImage',
      title: '选中图片'
    },
    'separator',
    {
      type: 'event',
      event: 'stop',
      title: '停止'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '开始',
      name: 'begin',
      dataSchema: [
        {
          key: 'targetNum',
          title: '目标位置索引',
          placeholder: '多个目标以逗号分隔'
        }
      ]
    }
  ];

  constructor (props: Props) {
    super(props)
    this.state = {
      currentNum: 0,
      speed: 1,
      drawDone: false,
      targetNum: ['-1']
    }
  }

  timer1: number;
  timer2: number;
  timer3: number;
  drawing: boolean;

  changeSpeed (number: number) {
    this.setState({
      speed: number
    })
  }

  changeCurrentNum (number: number) {
    this.setState({
      currentNum: number
    })
  }

  changeDrawDone (boolean: ?boolean) {
    this.setState({
      drawDone: !!boolean
    })
  }

  componentWillUnmount () {
    clearInterval(this.timer1)
    clearInterval(this.timer2)
    clearInterval(this.timer3)
  }

  actionBegin = (
    data: { targetNum?: string } = {},
    dynamicData: { targetNum: number }
  ) => {
    const { jsEnv } = this.props
    let targetNumStr = dynamicData.targetNum
    if (data && data.targetNum) {
      targetNumStr = jsEnv.getStringWithAdditionCtx(
        data.targetNum,
        dynamicData
      )
    }
    const targetNum = targetNumStr.toString().split(',')
    this.setState(
      {
        targetNum
      },
      () => {
        if (this.drawing) {
          return
        }
        this.drawing = true
        this.drawStart()
      }
    )
  };

  drawStart () {
    let { targetNum } = this.state
    if (targetNum.length > 1) {
      this.multiTarget()()
    } else {
      this.setSpeed()
    }
    this.setShowActiveAwardTimer()
  }

  sameSpeed = () => {
    return delayPromise(0)
      .then(() => {
        this.changeSpeed(2)
        return delayPromise(500)
      })
      .then(() => {
        this.changeSpeed(3)
        return delayPromise(500)
      })
      .then(() => {
        this.changeSpeed(4)
        return delayPromise(500)
      })
  };

  delayAndNum (
    ms: number,
    returnNum: number,
    clear: ?boolean,
    notCallAction?: boolean
  ) {
    return delayPromise(ms).then(() => {
      return new Promise(resolve => {
        let timer = (this.timer2 = setInterval(() => {
          if (+this.state.currentNum === +returnNum) {
            if (clear) {
              this.changeDrawDone(true)
              if (!notCallAction) {
                delayPromise(1500).then(() => {
                  this.props.callActions('stop')
                })
              }
            }
            clearInterval(timer)
            resolve()
          }
        }, 50))
      })
    })
  }

  setSpeed () {
    let { targetNum } = this.state
    this.sameSpeed()
      .then(() => {
        this.changeSpeed(5)
        return Promise.all([
          delayPromise(1000),
          new Promise(resolve => {
            let timer = setInterval(() => {
              if (targetNum) {
                clearInterval(timer)
                resolve()
              }
            }, 200)
          })
        ])
      })
      .then(() => {
        this.changeSpeed(4)
        return delayPromise(500)
      })
      .then(() => {
        this.changeSpeed(3)
        return this.delayAndNum(
          500,
          this.minusNum(parseInt(targetNum[0], 10), 2)
        )
      })
      .then(() => {
        this.changeSpeed(1)
        return this.delayAndNum(1000, parseInt(targetNum[0], 10), true)
      })
  }

  multiTarget = () => {
    const { targetNum } = this.state
    const promiseArray = targetNum.map((item, i) => {
      return () => {
        return (i > 0 ? delayPromise(0) : this.sameSpeed()).then(() => {
          this.changeSpeed(5)
          return this.delayAndNum(
            250,
            parseInt(item, 10),
            true,
            i + 1 < targetNum.length
          ).then(() => {
            if (i < targetNum.length - 1) {
              return delayPromise(400).then(() => {
                this.setShowActiveAwardTimer()
              })
            }
          })
        })
      }
    })
    let ps = []
    for (let i = 0; i < promiseArray.length; i++) {
      ps.push(() => {
        if (i === 0) {
          return promiseArray[i]()
        } else {
          return ps[i - 1]().then(() => {
            return promiseArray[i]()
          })
        }
      })
    }
    return ps[ps.length - 1]
  };

  minusNum (x: number, y: number) {
    let result = x - y
    while (result <= 0) {
      result += 8
    }
    return result
  }

  setShowActiveAwardTimer () {
    let num = this.state.currentNum
    let circleIndex = 0
    let timer = (this.timer1 = setInterval(() => {
      let { speed, drawDone } = this.state
      circleIndex++
      if (circleIndex % Math.pow(2, 5 - speed) !== 0) {
        return
      }
      if (drawDone) {
        clearInterval(timer)
        this.drawing = false
        this.changeDrawDone()
        return
      }
      this.showActiveAward(num)
      num++
      if (num > 8) {
        num = 1
      }
    }, 50))
  }

  showActiveAward (num: number) {
    let { currentNum } = this.state
    $(this.refs.award).removeClass('_' + currentNum)
    $(this.refs.award).addClass('_' + num)
    this.changeCurrentNum(num)
  }

  render () {
    let {
      customProps = {},
      jsEnv,
      children,
      visible,
      backgroundImage,
      defaultImage,
      turnImage
    } = this.props
    let { currentNum } = this.state
    let rectConfig =
      customProps.$comp && customProps.$comp.rectConfig
        ? customProps.$comp.rectConfig
        : {}
    backgroundImage = backgroundImage || rectConfig.backgroundImage || {}
    defaultImage = defaultImage || rectConfig.defaultImage || {}
    turnImage = turnImage || rectConfig.turnImage || {}
    let backgroundImageUrl = jsEnv.getString(backgroundImage.url || '')
    let defaultImageUrl = jsEnv.getString(defaultImage.url || '')
    let turnImageUrl = jsEnv.getString(turnImage.url || '')
    if (!visible) {
      return null
    }
    return (
      <div
        className={`${styles.this}`}
        style={{
          backgroundImage: `url(${backgroundImageUrl})`
        }}
      >
        <div style={{ position: 'relative' }}>
          <img
            src={defaultImageUrl}
            className='full'
            style={{ width: '6.4rem', height: '5.8rem' }}
          />
          <div
            ref='award'
            style={{
              backgroundImage: "url('" + turnImageUrl + "')",
              backgroundSize: '6.4rem 5.8rem'
            }}
            className={`${styles.award} ${styles['_' + currentNum]}`}
          />
        </div>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/RectZhuanPan.js